import Vue from 'vue'
import VueRouter from 'vue-router'
import main from '../views/main.vue'
import layout from '../views/layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'layout',
    component: layout,
    redirect: 'main',
    meta: {
      keepAlive: false //此组件不需要被缓存
    },
    children: [
      {
        path: '/',
        component: main,
        name: 'main'
      },
      {
        path: '/articleList',
        name: 'articleList',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/articleList.vue')
      },
      {
        path: '/articleDetail',
        name: 'articleDetail',
        component: () => import('../views/articleDetail.vue')
      },
      {
        path: '/peopleList',
        name: 'peopleList',
        component: () => import('../views/peopleList.vue')
      }
    ]
    // mode: 'history'
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
